import { FeedOutlined } from '@mui/icons-material';

import FactsheetDialogButtonBase from '@/components/FactsheetDialogButton/FactsheetDialogButtonBase';

const FactsheetDialogButton = ({
  code,
  fontSize = 16,
  mode
}: {
  code: string;
  fontSize?: number;
  mode?: 'modal' | 'newTab';
}) => {
  return (
    <FactsheetDialogButtonBase
      code={code}
      mode={mode}
    >
      <FeedOutlined sx={{ fontSize }} />
    </FactsheetDialogButtonBase>
  );
};
export default FactsheetDialogButton;
